export const alertCopy = {
  semAcesso: {
    "sem-credencial": (credencial: string) =>
      `A Nabla não encontrou a credencial do Google Drive (${credencial}), então não lê a pasta da equipe.`,
    "credencial-recusada": (credencial: string) =>
      `O Google recusou a credencial do Drive (${credencial}), então a Nabla não lê a pasta da equipe.`,
    "pasta-fechada": (credencial: string) => `A pasta do Drive da equipe não abre para a credencial da Nabla (${credencial}).`,
  },
  proximo: {
    "sem-credencial": "Peça a quem cuida da instalação da Nabla para pôr a chave da conta de serviço do Google na pasta de credenciais.",
    "credencial-recusada": "Peça a quem cuida da instalação da Nabla para fazer uma chave nova da conta de serviço e trocar o arquivo.",
    "pasta-fechada": "Compartilhe a pasta com o e-mail da conta de serviço da Nabla, como leitor.",
    "conta-recusada": "Conecte a conta Google de novo em Pasta do Google Drive.",
  },
} as const;
